var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.8794V10.1194C1 9.07945 1.85 8.21945 2.9 8.21945C4.71 8.21945 5.45 6.93945 4.54 5.36945C4.02 4.46945 4.33 3.29945 5.24 2.77945L6.97 1.78945C7.76 1.31945 8.78 1.59945 9.25 2.38945L9.36 2.57945C10.26 4.14945 11.74 4.14945 12.65 2.57945L12.76 2.38945C13.23 1.59945 14.25 1.31945 15.04 1.78945L16.77 2.77945C17.68 3.29945 17.99 4.46945 17.47 5.36945C16.56 6.93945 17.3 8.21945 19.11 8.21945C20.15 8.21945 21.01 9.06945 21.01 10.1194V11.8794C21.01 12.9194 20.16 13.7794 19.11 13.7794C17.3 13.7794 16.56 15.0594 17.47 16.6294C17.99 17.5394 17.68 18.6994 16.77 19.2194L15.04 20.2094C14.25 20.6794 13.23 20.3994 12.76 19.6094L12.65 19.4194C11.75 17.8494 10.27 17.8494 9.36 19.4194L9.25 19.6094C8.78 20.3994 7.76 20.6794 6.97 20.2094L5.24 19.2194C4.33 18.6994 4.02 17.5294 4.54 16.6294C5.45 15.0594 4.71 13.7794 2.9 13.7794C1.85 13.7794 1 12.9194 1 11.8794Z",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.c3229da00d4451bc5fe6df3038cb3061.svg";
export { ForwardRef as ReactComponent };